import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProfileStatus from './profile-status-model'
import {
  CreateProfileStatusAsync,
  DeleteProfileStatusAsync,
  LoadProfileStatussAsync,
} from './profileStatus-thunk'
const initialState: profileStatusSliceState = {
  profileStatus: [],
  selected_profileStatus: '',
  is_loading_profileStatus: false,
  is_creating_profileStatus: false,
  is_deleting_profileStatus: false,
}
export interface profileStatusSliceState {
  profileStatus: ProfileStatus[]
  selected_profileStatus?: string
  is_loading_profileStatus: boolean
  is_creating_profileStatus: boolean
  is_deleting_profileStatus: boolean
}
export const profileStatusSlice = createSlice({
  name: 'profileStatus',
  initialState,
  reducers: {
    setSelectedprofileStatus: (state, action) => {
      state.selected_profileStatus = action.payload
    },
    clearStateprofileStatus: (state) => {
      state.profileStatus = []
      state.is_loading_profileStatus = false
      state.is_creating_profileStatus = false
      state.is_deleting_profileStatus = false
    },
    mergeprofileStatus: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_profileStatus = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.profileStatus = merge(state.profileStatus, payload) as any
        }
      }
    },

    add_profileStatus: (state, action) => {
      if (action.payload) {
        state.profileStatus = [...state.profileStatus, action.payload]
      }
    },
    set_profileStatus: (state, action) => {
      let { key, value, id } = action.payload
      state.profileStatus = state.profileStatus.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProfileStatussAsync.pending, (state) => {
      state.is_loading_profileStatus = true
    })
    builder.addCase(LoadProfileStatussAsync.fulfilled, (state, action) => {
      state.is_loading_profileStatus = false
      if (action.payload) {
        state.profileStatus = action.payload
      }
    })
    builder.addCase(LoadProfileStatussAsync.rejected, (state) => {
      state.is_loading_profileStatus = false
    })
    builder.addCase(CreateProfileStatusAsync.pending, (state) => {
      state.is_creating_profileStatus = true
    })
    builder.addCase(CreateProfileStatusAsync.fulfilled, (state) => {
      state.is_creating_profileStatus = false
    })
    builder.addCase(CreateProfileStatusAsync.rejected, (state) => {
      state.is_creating_profileStatus = false
    })
    builder.addCase(DeleteProfileStatusAsync.pending, (state) => {
      state.is_deleting_profileStatus = true
    })
    builder.addCase(DeleteProfileStatusAsync.fulfilled, (state, action) => {
      state.is_deleting_profileStatus = false
      if (state.profileStatus) {
        state.profileStatus = state.profileStatus.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProfileStatusAsync.rejected, (state) => {
      state.is_deleting_profileStatus = false
    })
  },
})

export const {
  clearStateprofileStatus,
  setSelectedprofileStatus,
  set_profileStatus,
  mergeprofileStatus,
  add_profileStatus,
} = profileStatusSlice.actions

export const get_profileStatus =
  (id?: string) =>
  (state: {
    profileStatus: {
      profileStatus: ProfileStatus[]
    }
  }): ProfileStatus | null => {
    let temp = state?.profileStatus?.profileStatus?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.profileStatus?.profileStatus[0] || null
  }
export const get_selected_profileStatus = (state: {
  profileStatus: profileStatusSliceState
}): ProfileStatus | null => {
  let id = state?.profileStatus?.selected_profileStatus
  let temp = state?.profileStatus?.profileStatus?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_profileStatus = (state: {
  profileStatus: {
    profileStatus: ProfileStatus[]
  }
}): ProfileStatus[] => {
  let temp = state?.profileStatus?.profileStatus
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_profileStatus_busy = (state: {
  profileStatus: profileStatusSliceState
}) => {
  return (
    state?.profileStatus.is_deleting_profileStatus ||
    state?.profileStatus.is_loading_profileStatus ||
    state?.profileStatus.is_creating_profileStatus
  )
}
export const is_deleting_profileStatus_busy = (state: {
  profileStatus: profileStatusSliceState
}) => {
  return state?.profileStatus.is_deleting_profileStatus
}
export const is_loading_profileStatus_busy = (state: {
  profileStatus: profileStatusSliceState
}) => {
  return state?.profileStatus.is_loading_profileStatus
}
export const is_creating_profileStatus_busy = (state: {
  profileStatus: profileStatusSliceState
}) => {
  return state?.profileStatus.is_creating_profileStatus
}

export default profileStatusSlice.reducer
